// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.liberawallet",
    name: "Libera",
    homepage: "https://liberawallet.com",
    image_id: "9485d17f-c413-47fe-ebee-a876a9dc9100",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.impactmarket.mobile&&pli=1",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "libera://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map